import SearchInput, { SearchInputRounded } from "./styles";

export default SearchInput;
export { SearchInputRounded };